<template>
  <div class="mt-5">
    <section-title
      content="Información General del Proponente"
      icon="fas fa-info"
      reverse
    />
    <div class="bg-secondary-3 rounded pr-3 pl-3 mt-5 pb-4 pt-4">
      <div class="row mb-5">
        <div class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Nombre del Representante Autorizado:
          </div>
          <div class="color-black font-16">
            {{ data.nameAuthorizedRepresentative | empty }}
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Correo Electrónico:
          </div>
          <div class="color-black font-16">
            {{ data.email | empty }}
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Teléfono:
          </div>
          <div class="color-black font-16">
            {{ data.phone | phone }}
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <div class="color-gray-6 font-14">
            Dirección Postal:
          </div>
          <div class="color-black font-16">
            {{ data.address | empty }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Tipo de Contratación:
          </div>
          <div class="color-black font-16">
            {{ data.contractType | empty }}
          </div>
        </div>
        <div
          class="col-12 col-md-3"
          :class="{ 'col-md-6': isProfessionalServices }"
        >
          <div class="color-gray-6 font-14">
            Nombre del Proponente:
          </div>
          <div class="color-black font-16">
            {{ data.nameProposer | empty }}
          </div>
        </div>
        <div v-if="isProvisionalRemedyArea" class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Seguro social:
          </div>
          <div class="color-black font-16">
            {{ data.socialSecurityNo | empty }}
          </div>
        </div>
        <div v-if="isProvisionalRemedyArea" class="col-12 col-md-3 mb-5">
          <div class="color-gray-6 font-14">
            Tiempo ofreciendo los servicios:
          </div>
          <div class="color-black font-16">
            {{ data.serviceOfferTimeAndTerm | empty }}
          </div>
        </div>
        <div v-if="isProvisionalRemedyArea" class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Profesión del Proponente:
          </div>
          <div class="color-black font-16">
            {{ data.providerProfession | empty }}
          </div>
        </div>
        <div v-if="isProvisionalRemedyArea" class="col-12 col-md-3">
          <div class="color-gray-6 font-14">
            Profesión del Representante:
          </div>
          <div class="color-black font-16">
            {{ data.representativeProfession | empty }}
          </div>
        </div>
        <div
          v-if="!isProvisionalRemedyArea && !isProfessionalServices"
          class="col-12 col-md-3"
        >
          <div class="color-gray-6 font-14">
            Número de RUL:
          </div>
          <div class="color-black font-16">
            {{ data.rulNumber | empty }}
          </div>
        </div>
        <div
          v-if="!isProvisionalRemedyArea"
          class="col-12 col-md-3 position-relative mt-n5"
        >
          <div class="bg-white rounded pr-3 pl-3 pb-4 pt-4">
            <div class="color-gray-6 font-14">
              <i class="fas fa-usd-circle mr-2 text-success h4" />
              Monto Total de la Propuesta a Someter:
            </div>
            <div
              class="ml-4"
              :class="`font-${getAmountFontSize(`${data.amount}`)}`"
            >
              {{ data.amount | price }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';

//constants
const MIN_OUT_OF_BOUND_SIZE = 10;

export default {
  name: 'GeneralInformation',
  components: {
    SectionTitle,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isProvisionalRemedyArea: {
      type: Boolean,
      default: false,
    },
    isProfessionalServices: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    getAmountFontSize() {
      return (amount) => (amount.length >= MIN_OUT_OF_BOUND_SIZE ? 22 : 32);
    },
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@import '../../../../shared/scss/config/_colors.scss';

.bg-custom-gray {
  background-color: map-get($colors, 'secondary-3');
}
</style>
